(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-julia-product-recommendations"] && !Shopify.designMode) return;
  try {
    
   var loadProductRecommendationsIntoSection = function() {
     var productRecommendationsSection = document.querySelector(".sh-product-recommendations");
     if (productRecommendationsSection === null) { return; }
     var productId = productRecommendationsSection.dataset.productId;
     var baseUrl = productRecommendationsSection.dataset.baseUrl;
     var limit = productRecommendationsSection.dataset.limit;
     var requestUrl = baseUrl + "?section_id=sh-julia-product-recommendations&product_id=" + productId;
     var request = new XMLHttpRequest();
     request.open("GET", requestUrl);
     request.onload = function() {
       if (request.status >= 200 && request.status < 300) {
         var container = document.createElement("div");
         container.innerHTML = request.response;
         productRecommendationsSection.parentElement.innerHTML = container.querySelector(".sh-product-recommendations").innerHTML;
         if('jQuery' in window && 'sh' in window && 'init' in window.sh) {
			window.sh.init(jQuery('body'));
		 }         
       }
     };
     request.send();
   };

   document.addEventListener("shopify:section:load", function(event) {
     if (event.detail.sectionId === "sh-julia-product-recommendations") {
       loadProductRecommendationsIntoSection();
     }
   });
   loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
